<template>
  <div>
    <b-modal
      id="confirm-interview-modal"
      :title="$t('interview_completed')"
      centered
      cancel-variant="outline-secondary"
      ok-variant="primary"
      :ok-title="$t('ok')"
      cancel-title="Peru"
      @ok="confirmInterview"
    >
      <p class="m-0">
        {{ $t('application.interviewCard.mark_interview_completed_warning') }}
      </p>
    </b-modal>
    <b-modal
      id="confirm-valvira-modal"
      :title="$t('application.interviewCard.valviraModal.title')"
      centered
      cancel-variant="outline-secondary"
      ok-variant="primary"
      :ok-title="$t('application.interviewCard.valviraModal.okTitle')"
      :cancel-title="$t('application.interviewCard.valviraModal.cancelTitle')"
      @ok="confirmValvira"
    >
      <p class="m-0">
        {{ $t('application.interviewCard.valviraModal.warningConfirmText') }}
      </p>
    </b-modal>
    <b-modal
      id="cancel-valvira-modal"
      :title="$t('application.interviewCard.valviraModal.title')"
      centered
      cancel-variant="outline-secondary"
      ok-variant="danger"
      :ok-title="$t('application.interviewCard.valviraModal.okTitle')"
      :cancel-title="$t('application.interviewCard.valviraModal.cancelTitle')"
      @ok="cancelValvira"
    >
      <p class="m-0">
        {{ $t('application.interviewCard.valviraModal.warningCancelText') }}
      </p>
    </b-modal>
    <b-modal
      id="question-modal"
      size="lg"
      :title="$t('application.questionModal.header')"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      :cancel-title="$t('application.questionModal.cancelBtn')"
      :ok-title="$t('application.questionModal.sendBtn')"
      @show="onModalOpen"
      @ok="handleCreate"
    >
      <validation-observer ref="rules">
        <b-form ref="form" @submit.stop.prevent="handleSubmit">
          <b-col cols="12">
            <b-form-group label="Template" label-for="template">
              <b-dropdown 
                variant="outline-secondary"
                block
                menu-class="w-100"
                :text="templateTitle"
              >
                <template v-if="interviewTemplates.length > 0">
                  <div
                    v-for="(template, index) in interviewTemplates"
                    :key="index"
                    class="d-flex justify-content-between align-items-center"
                  >
                    <b-dropdown-item
                      class="w-100"
                      @click="setTemplate(template.value)"
                    >
                      {{ template.label }}
                    </b-dropdown-item>
                    <b-button v-b-modal.modal-delete-template variant="link" flat class="border-0" size="sm" @click="tempDeleteIndex = index">
                      <feather-icon
                        icon="XIcon"
                        size="16"
                        style="color: red"
                      />
                    </b-button>
                  </div>
                </template>
                <b-dropdown-text v-else>{{ $t('no_items') }}</b-dropdown-text>
              </b-dropdown>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('application.questionModal.email_header')" label-for="emails">
              <validation-provider
                #default="{ errors }"
                :name="$t('application.questionModal.email_header')"
                rules="required"
              >
                <b-form-input
                  id="emails"
                  v-model="form.email"
                  :placeholder="$t('application.questionModal.email_placeholder')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col>
            <hr />
          </b-col>

          <b-col cols="12">
            <b-row
              v-for="step in form.steps"
              :id="form.steps.indexOf(step)"
              :key="form.steps.indexOf(step)"
              ref="row"
              class="question-item"
            >
              <b-col cols="9">
                <b-form-group
                  :label="
                    step.questionType === 'info'
                      ? $t('application.questionModal.info')
                      : $t('application.questionModal.question')
                  "
                  :label-for="step.questionType === 'info' ? 'answer' : 'question'"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="
                      step.questionType === 'info'
                        ? $t('application.questionModal.info')
                        : $t('application.questionModal.question')
                    "
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea"
                      v-model="step.question"
                      rows="1"
                      max-rows="3"
                      :placeholder="
                        step.questionType === 'info'
                          ? $t('application.questionModal.info_placeholder')
                          : $t('application.questionModal.question_placeholder')
                      "
                    />
                    <!-- <small
                      v-if="!step.question || !step.question.length"
                      class="text-danger"
                    >{{ $t('application.questionModal.question_warning') }}</small> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="2" class="p-0 pr-2">
                <b-form-group
                  :label="$t('application.questionModal.questionType')"
                  label-for="questionType"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('application.questionModal.questionType')"
                    rules="required"
                  >
                    <v-select
                      id="questionType"
                      v-model="step.questionType"
                      :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                      :label="$t('application.questionModal.questionType')"
                      style="text-transform: capitalize"
                      :clearable="false"
                      :options="questionTypeOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="1" class="d-flex justify-content-end">
                <b-button
                  variant="outline-danger"
                  :disabled="form.steps.indexOf(step) === 0"
                  @click="onRemoveQuestion(form.steps.indexOf(step))"
                >
                  <feather-icon icon="XSquareIcon" />
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12">
            <hr />
          </b-col>

          <b-col cols="12">
            <b-button variant="outline-primary" @click="addQuestion()">
              {{ $t('application.questionModal.addQuestionBtn') }}
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
          <b-row>
            <b-col lg="8">
              <b-form-input v-model="templateName" />
            </b-col>
            <b-col lg="4">
              <b-button
                :disabled="templateName.length < 1"
                variant="outline-info"
                @click.prevent="handleSave()"
              >
                Save As Template
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>

      <template #modal-footer="{cancel}">
        <b-button variant="outline-secondary" @click="cancel()">
          {{ $t('application.questionModal.cancelBtn') }}
        </b-button>
        <b-button variant="primary" @click.prevent="handleCreate()">
          {{ $t('application.questionModal.sendBtn') }}
        </b-button>
      </template>
    </b-modal>

    <document-request-modal
      :user-data="userData"
      @create-document-request="handleCreateDocumentRequest"
    />

    <b-card :title="$t('next_recommended_action')">
      <div v-if="getNextReccomendedStep === 'accept_or_reject_step'">
        <h6 class="card-subtitle text-muted mb-2">
          {{ $t('application.interviewCard.acceptOrRejectTitle') }}
        </h6>
        <b-button v-b-modal.modal-accept variant="success" block :disabled="isDisabledAccepted">
          <feather-icon icon="ThumbsUpIcon" class="mr-50" />
          {{ $t('application.interviewCard.acceptBtn') }}
        </b-button>
        <b-button v-b-modal.modal-reject variant="danger" block>
          <feather-icon icon="ThumbsDownIcon" class="mr-50" />
          {{ $t('application.interviewCard.rejectBtn') }}
        </b-button>
      </div>
      <div v-if="getNextReccomendedStep === 'wait_interview_step'">
        <h6 class="card-subtitle text-muted mb-2">
          {{ $t('application.interviewCard.awaitApplicantReponse') }}
        </h6>
        <b-button
          v-b-modal.confirm-interview-modal
          variant="outline-primary"
          block
          @click="showConfirmModal()"
        >
          {{ $t('application.interviewCard.markInterviewCompleted') }}
        </b-button>
      </div>
      <div v-if="getNextReccomendedStep === 'check_documents_step'">
        <h6 class="card-subtitle text-muted mb-2">
          <u>{{ $t('application.interviewCard.checkDocuments') }}</u>
        </h6>
      </div>
      <div v-if="getNextReccomendedStep === 'listen_interview_step'">
        <h6 class="card-subtitle text-muted mb-2">
          {{ $t('application.interviewCard.listenAnswers') }}
        </h6>
        <b-button
          v-b-modal.confirm-interview-modal
          variant="outline-primary"
          block
          @click="showConfirmModal()"
        >
          {{ $t('application.interviewCard.markInterviewCompleted') }}
        </b-button>
      </div>
      <div v-if="getNextReccomendedStep === 'request_documents_step'">
        <h6 class="card-subtitle text-muted mb-2">
          {{ $t('application.interviewCard.askedForDocuments') }}
        </h6>
        <b-button v-b-modal.document-request-modal block variant="outline-warning">
          <feather-icon icon="FileTextIcon" class="mr-50" />
          {{ $t('application.interviewCard.requestDocuments') }}
        </b-button>
      </div>
      <div v-if="getNextReccomendedStep === 'valvira_check_step'">
        <h6 class="card-subtitle text-muted mb-2">
          {{ $t('application.interviewCard.valviraCheckSubTitle') }}
          <ul>
            <li>{{ $t('application.interviewCard.valviraListItems.firstName') }}</li>
            <li>{{ $t('application.interviewCard.valviraListItems.lastName') }}</li>
            <li>{{ $t('application.interviewCard.valviraListItems.birthYear') }}</li>
            <li>
              {{ $t('application.interviewCard.valviraListItems.title') }}
              (lähihoitaja/sairaanhoitaja/terveydenhoitaja)
            </li>
          </ul>
          {{ $t('application.interviewCard.areConsistent') }}
        </h6>
        <b-button
          variant="outline-info"
          block
          href="https://julkiterhikki.valvira.fi/"
          target="_blank"
        >
          {{ $t('application.interviewCard.openValvira') }}
        </b-button>
        <b-button v-b-modal.confirm-valvira-modal variant="outline-primary" block>
          {{ $t('application.interviewCard.confirmValvira') }}
        </b-button>
        <b-button v-b-modal.cancel-valvira-modal variant="outline-danger" block>
          {{ $t('application.interviewCard.noValvira') }}
        </b-button>
      </div>
      <div v-if="getNextReccomendedStep === 'send_interview_step'">
        <h6 class="card-subtitle text-muted mb-2">
          {{ $t('application.interviewCard.interviewApplicant') }}
        </h6>
        <b-button
          v-b-modal.question-modal
          block
          variant="outline-info"
          :disabled="isCreatingInterview"
        >
          <feather-icon icon="MessageSquareIcon" class="mr-50" />
          {{ $t('application.interviewCard.sendInterview') }}
        </b-button>
        <b-button
          v-if="appConfig.type === 'hw-admin'"
          variant="secondary"
          block
          @click="
            () => {
              interviewing = false
              $emit('action', 'no_answer', { duration: 0 })
              handleMissedCall()
            }
          "
        >
          <feather-icon icon="PhoneOffIcon" class="mr-50" />
          {{ $t('application.interviewCard.callNotAnswered') }}
        </b-button>
        <b-button v-if="appConfig.type === 'hw-admin'" v-b-modal.modal-schedule block variant="warning">
          <feather-icon icon="CalendarIcon" class="mr-50" />
          {{ $t('application.interviewCard.bookInterviewCall') }}
        </b-button>
        <b-button
          v-b-modal.confirm-interview-modal
          variant="outline-primary"
          block
          @click="showConfirmModal()"
        >
          {{ $t('application.interviewCard.markInterviewCompleted') }}
        </b-button>
      </div>
      <b-button
        v-if="getNextReccomendedStep !== 'check_documents_step'"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-toggle.all-actions
        style="margin-top: 20px"
        variant="flat-primary"
        size="sm"
      >
        {{ $t('application.interviewCard.showAllFunction') }}
      </b-button>
      <b-collapse id="all-actions" class="mt-2">
        <div>
          <!-- Right Col: Table -->
          <b-col cols="12" class="d-flex justify-content-center flex-row">
            <b-row>
              <b-button
                v-if="appConfig.type === 'hw-admin'"
                variant="outline-info"
                block
                href="https://julkiterhikki.valvira.fi/"
                target="_blank"
              >
                {{ $t('application.interviewCard.openValvira') }}
              </b-button>
              <b-button v-if="appConfig.type === 'hw-admin'" v-b-modal.confirm-valvira-modal variant="outline-primary" block>
                {{ $t('application.interviewCard.confirmValvira') }}
              </b-button>
              <b-button v-if="appConfig.type === 'hw-admin'" v-b-modal.cancel-valvira-modal variant="outline-danger" block>
                {{ $t('application.interviewCard.noValvira') }}
              </b-button>
              <b-button
                v-if="appConfig.type === 'hw-admin'"
                variant="secondary"
                block
                @click="
                  () => {
                    interviewing = false
                    $emit('action', 'no_answer', { duration: 0 })
                    handleMissedCall()
                  }
                "
              >
                <feather-icon icon="PhoneOffIcon" class="mr-50" />
                {{ $t('application.interviewCard.callNotAnswered') }}
              </b-button>
              <b-button v-if="appConfig.type === 'hw-admin'" v-b-modal.modal-schedule block variant="warning">
                <feather-icon icon="CalendarIcon" class="mr-50" />
                {{ $t('application.interviewCard.bookInterviewCall') }}
              </b-button>

              <b-button
                v-b-modal.question-modal
                block
                variant="outline-info"
                :disabled="isCreatingInterview"
              >
                <feather-icon icon="MessageSquareIcon" class="mr-50" />
                {{ $t('application.interviewCard.sendInterview') }}
              </b-button>

              <b-button v-b-modal.document-request-modal block variant="outline-warning">
                <feather-icon icon="FileTextIcon" class="mr-50" />
                {{ $t('application.interviewCard.requestDocuments') }}
              </b-button>
              <div
                style="width:100%; border-bottom: 1px solid #e5e5e5; margin-top: 10px; margin-bottom: 10px"
              />
              <b-button
                v-b-modal.modal-accept
                variant="success"
                block
                :disabled="isDisabledAccepted"
              >
                <feather-icon icon="ThumbsUpIcon" class="mr-50" />
                {{ $t('application.interviewCard.acceptBtn') }}
              </b-button>
              <b-button v-b-modal.modal-reject variant="danger" block>
                <feather-icon icon="ThumbsDownIcon" class="mr-50" />
                {{ $t('application.interviewCard.rejectBtn') }}
              </b-button>
            </b-row>
          </b-col>
        </div>
      </b-collapse>
    </b-card>
    <b-modal
      id="modal-schedule"
      title="Schedule "
      no-fade
      ok-only
      :ok-disabled="!schedule"
      ok-title="Schedule"
      @ok="handleScheduling"
    >
      <b-card-text>
        Muista ilmoittaa työntekijälle erikseen haastattelu ajasta sekä muista kirjata haastattelu
        aika omaan kalenteriisi.
      </b-card-text>
      <div class="mt-1" style="justify-content: center; align-items: center">
        <flat-pickr
          v-model="schedule"
          class="form-control"
          :config="{ enableTime: true, minDate: new Date(), time_24hr: true, inline: true }"
        />
      </div>
    </b-modal>
    <b-modal
      id="modal-reject"
      title="Reject"
      no-fade
      ok-only
      :ok-disabled="rejectReason.length < 2"
      ok-title="Confirm"
      @ok="handleReject"
    >
      <b-form-textarea
        id="textarea-reject"
        v-model="rejectReason"
        placeholder="Syy hylkäämiseen..."
        rows="3"
      />
    </b-modal>
    <b-modal
      id="modal-accept"
      title="Hyväksy"
      no-fade
      ok-only
      :ok-disabled="canSubmit"
      ok-title="Hyväksy"
      @ok="handleAccept"
    >
      <b-form-group
        v-if="userData.profession == 'opiskelija'"
        label="Opintotyyppi"
        label-for="diplomaDocument"
      >
        <b-form-radio-group
          v-model="studyType"
          value-field="item"
          text-field="name"
          :options="[
            {
              name: 'lähihoitajaopiskelija',
              item: 'lähihoitajaopiskelija',
            },
            {
              name: 'sairaanhoitajaopiskelija',
              item: 'sairaanhoitajaopiskelija',
            },
          ]"
          name="radio-inline"
        />
        <b-form-group
          :label="$t('application.documentList.credits.label')"
          label-for="diplomaDocument"
          style="margin-top: 10px"
        >
          <b-form-input
            id="credits"
            v-model="creditPoints"
            :value="23"
            placeholder="Opintopisteet"
            type="number"
          />
        </b-form-group>
        <div v-if="canWorkAs">
          <p :style="'color:' + (canWorkAs.value ? 'green' : 'red')">
            {{ canWorkAs.text }}
          </p>
        </div>
        <b-card style="margin-top: 10px">
          <b-card-body style="font-size: 12px;">
            <p>
              <b>Lähihoitajaopiskelija:</b> On opiskelija joka suorittaa tällä hetkellä lähihoitajan
              tutkintoa.
              <br />
              <em>Vähintään: 30 op vaaditaan jotta voi tehdä töitä lähihoitajan nimikkeellä.</em>
            </p>
            <p>
              <b>Sairaanhoitajaopiskelija:</b> On opiskelija joka suorittaa tällä hetkellä
              sairaanhoitajan tutkintoa.
              <br />
              <em>Vähintään: 60 op vaaditaan jotta voi tehdä töitä lähihoitajan nimikkeellä.</em>
              <br />
              <em>Vähintään: 140 op vaaditaan jotta voi tehdä töitä sairaanhoitajan nimikkeellä.</em
              >
            </p>
          </b-card-body>
        </b-card>
      </b-form-group>
      <b-form-textarea
        id="textarea-reject"
        v-model="acceptReason"
        placeholder="Huomioitavaa, esim ei lähettänyt todistuksia viellä..."
        rows="3"
      />
    </b-modal>
    <b-modal
      id="modal-delete-template"
      :title="$t('delete_template')"
      no-fade
      :ok-title="$t('confirm')"
      ok-variant="outline-danger"
      @ok="handleDeleteTemplate"
    >
      <b-card-text>
        {{ $t('delete_template_warning') }}
      </b-card-text>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import store from '@/shared/store'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import {
  BCard,
  BCardBody,
  BButton,
  BRow,
  BCol,
  BModal,
  VBModal,
  BCardText,
  BFormTextarea,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BCollapse,
  BDropdown,
  BDropdownItem,
  BDropdownText,
  VBToggle,
} from 'bootstrap-vue'
import { avatarText } from '@hw-ui/utils/filter'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import useApplicationsList from '../applications-list/useApplicationsList'
import DocumentRequestModal from './DocumentRequestModal.vue'
import { TOAST_VARIABLES } from '@hw-ui/components/toastification/constant'

export default {
  components: {
    BCard,
    BCardBody,
    BButton,
    BRow,
    BCol,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BCardText,
    BCollapse,
    flatPickr,
    BFormTextarea,
    BFormRadioGroup,
    BDropdown,
    BDropdownItem,
    BDropdownText,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    DocumentRequestModal,
  },
  directives: {
    'b-modal': VBModal,
    'b-toggle': VBToggle,
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    interview: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      schedule: null,
      startTime: null,
      interviewing: false,
      accepted: false,
      studyType: null,
      templateName: '',
      creditPoints: this.userData.studies ? parseInt(this.userData.studies.credits, 10) : 0,
      templateSelection: null,
      rejectReason: '',
      acceptReason: '',
      messageMissedCall: '',
      form: {
        email: '',
        steps: [
          {
            question: null,
            questionType: 'text',
          },
        ],
      },
      questionTypeOptions: ['text', 'audio', 'info'],
      formValid: false,
      processer: null,
      isCreatingInterview: false,
      tempDeleteIndex: -1,
    }
  },
  computed: {
    canSubmit() {
      if (this.userData.profession === 'opiskelija') {
        return this.acceptReason.length < 2 || this.studyType === null || !this.creditPoints
      }
      return this.acceptReason.length < 2
    },
    canWorkAs() {
      if (this.studyType === 'lähihoitajaopiskelija') {
        if (this.creditPoints >= 30) {
          return { text: 'Saa työskennellä lähihoitajana', value: 'lähihoitaja' }
        }
        return { text: 'Liian vähän opintopisteitä', value: '' }
      }
      if (this.studyType === 'sairaanhoitajaopiskelija') {
        if (this.creditPoints >= 60 && this.creditPoints < 140) {
          return { text: 'Saa työskennellä lähihoitajana', value: 'lähihoitaja' }
        }
        if (this.creditPoints >= 140) {
          return { text: 'Saa työskennellä sairaanhoitajana', value: 'sairaanhoitaja' }
        }
        return { text: 'Liian vähän opintopisteitä', value: '' }
      }
      return null
    },
    isDisabledAccepted() {
      return false
    },
    getNextReccomendedStep() {
      if (!this.userData.valviraChecked && this.appConfig.type === 'hw-admin') {
        return 'valvira_check_step'
      }
      if ((!this.interview.id && !this.userData.isInterviewed) || (!this.userData.valviraChecked && this.appConfig.type === 'ow-admin' && !this.interview.id && !this.userData.isInterviewed)) {
        return 'send_interview_step'
      }
      if (
        !this.userData.isInterviewed &&
        this.interview.id &&
        !this.interview.submitted &&
        this.interview.expiredDate.toDate() < new Date()
      ) {
        return 'send_interview_step'
      }
      if (
        !this.userData.isInterviewed &&
        this.interview.id &&
        !this.interview.submitted &&
        this.interview.expiredDate.toDate() > new Date()
      ) {
        return 'wait_interview_step'
      }
      if (this.interview.id && this.interview.submitted && !this.userData.isInterviewed) {
        return 'listen_interview_step'
      }
      if (
        this.userData.isInterviewed &&
        (!this.userData.requestedDocuments || this.userData.requestedDocuments.length < 1)
      ) {
        return 'request_documents_step'
      }
      if (
        this.userData.requestedDocuments &&
        this.userData.requestedDocuments.filter(document => !document.confirmed).length > 0
      ) {
        return 'check_documents_step'
      }
      if (
        this.userData.requestedDocuments &&
        this.userData.requestedDocuments.length > 0 &&
        this.userData.requestedDocuments.filter(document => !document.confirmed).length === 0
      ) {
        return 'accept_or_reject_step'
      }
      return 'no_step'
    },
    templateTitle() {
      if (this.templateSelection) {
        const templateMatch = this.interviewTemplates.find(i => i.value == this.templateSelection);
        return templateMatch ? templateMatch.label : this.$t('selecte_template')
      }
      return this.$t('selecte_template')
    },
    appConfig() {
      return this.$store.state.app.appConfig || {}
    },
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser').then(res => {
      const user = JSON.parse(JSON.stringify(res))
      this.processer = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
      }
    })
  },
  methods: {
    formatMobile(mobile) {
      if (mobile.charAt(0) === '0') {
        return `+358${mobile.substring(1)}`
      }
      if (mobile.charAt(0) !== '+') {
        return `+358${mobile}`
      }

      return mobile
    },
    showConfirmModal() {
      this.$bvModal.show('confirm-interview-modal')
    },
    confirmValvira() {
      this.$emit('action', 'confirm_valvira', { duration: 0, content: {} })
    },
    cancelValvira() {
      this.$emit('action', 'no_valvira', { duration: 0, content: {} })
    },
    confirmInterview() {
      this.$emit('action', 'confirm_interview', { duration: 0, content: {} })
    },
    setTemplate(val) {
      this.templateSelection = val
      this.form.steps = val.steps
    },
    async createNewInterview(form) {
      const { firstName, lastName } = this.userData
      const id = await store.dispatch('appApplications/createInterview', {
        form: {
          ...form,
          firstName,
          lastName,
          interviewer: this.processer,
        },
      })
      return id
    },
    async updateInterview(id, newState) {
      await store.dispatch('appApplications/updateInterview', { id, newState })
    },
    async createTemplate(form) {
      await store.dispatch('appApplications/createInterview', {
        form,
      })
    },
    async sendInterviewEmail(form, id) {
      const { firstName, mobile, email } = this.userData
      const firstNameCapitalized = firstName.charAt(0).toUpperCase() + firstName.slice(1)
      const expireDate = form.expiredDate.toLocaleString('fi', { month: 'long', day: 'numeric' })
      const message = `<p style="text-transform: capitalize">Hei ${firstName},</p>
                  <p>Kiitos hakemuksestasi! Haluaisimme tutustua sinuun paremmin. Ohessa linkki Hoiwan online-haastatteluun.</p>
                  <p>Online-haastattelu tehdään itsenäisesti ja se koostuu infomateriaalista ja kysymyksistä. </p>
                  <p><b>Kysymyksiin vastataan äänittämällä, joten varmista, että sinulla on laite, joka tukee äänittämistä (esimerkiksi puhelin tai tietokone, jossa on mikrofoni).</b></p>
                  <p>Haastattelun linkki on voimassa <b>${expireDate}</b> asti. Haastattelu vie aikaa noin <b>5 minuuttia</b> ja löydät sen täältä:</p>
                  <p><a href="https://hoiwa-haastattelu.web.app/${id}">Aloita haastattelu</a></p>
                  <p>Mikäli et saa online-haastattelua toimimaan, tarkista seuraavat kohdat:</p>
                  <ul>
                    <li>Suosittelemme käyttämään Chrome-selainta: <a href="https://www.google.com/chrome/" target="_blank">Lataa Chrome</a></li>
                    <li>Jos käytät mobiililaitetta, varmista, että olet antanut selaimellesi luvan käyttää mikrofonia. Ohessa linkki ohjeisiin: <a href="https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DAndroid" target="_blank">Android</a> <a href="https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DiOS&oco=0" target="_blank">iOS</a></li>
                    <li>Mikäli mikrofoni ja nauhoitus eivät edelleenkään toimi, mene puhelimen asetuksiin ja tarkista onko selaimella varmasti oikeudet mikrofonin käyttöön. Ohessa ohjeet: <a href="https://support.google.com/android/answer/9431959?hl=en">Android</a></li>
                    <li>Jos online-haastattelu ei vieläkään toimi, ota yhteyttä info@hoiwa.fi otsikolla:  <b>Haastattelu ei toimi</b>.</li>
                  </ul>
                  <p>Ystävällisin terveisin,</p>
                  <p>Hoiwa - tiimi</p>
                  `
      const subject = 'Hoiwa online-haastattelu kutsu.'
      const smsMessage = `Hei ${firstNameCapitalized}, Kiitos hakemuksestasi! Haluaisimme tutustua sinuun paremmin. Ohessa linkki Hoiwan online-haastatteluun. Haastattelun linkki on voimassa ${expireDate} asti. Haastattelu vie aikaa noin 5 minuuttia ja löydät sen täältä: https://hoiwa-haastattelu.web.app/${id}. Löydät myös linkin sähköpostistasi (tarkista myös roskaposti). Mikäli et saa online-haastattelua toimimaan, ota yhteyttä info@hoiwa.fi.`
      // Send sms
      try {
        await store.dispatch('appApplications/sendSMS', {
          mobile: this.formatMobile(mobile),
          message: smsMessage,
        })
        await store.dispatch('appApplications/sendInterviewEmail', {
          to: email,
          message,
          subject,
        })
      } catch(e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async onCreateInterview(form) {
      let id
      if (!this.interview || !this.interview.id) {
        id = await this.createNewInterview(form)
      } else {
        id = this.interview.id
        await this.updateInterview(id, { expiredDate: form.expiredDate })
      }
      await this.sendInterviewEmail(form, id)
    },
    handleScheduling() {
      const scheduleDate = new Date(this.schedule)
      this.interviewing = false
      const message = `${scheduleDate.toLocaleString('fi', {
        weekday: 'long',
        day: 'numeric',
        month: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      })}`
      this.$emit('action', 'schedule', { duration: 0, content: { date: scheduleDate, message } })
      const { firstName } = this.userData
      const to = this.userData.email
      const body = `<p style="text-transform: capitalize">Hei ${firstName},</p>
                       <p>Varasimme sinulle puhelinhaastattelu ajan, ajalle:</p>
                       <p style="text-transform: capitalize"><b>${message}</b></p>
                       <p>Ystävällisin terveisin,</p>
                       <p>Hoiwa - tiimi</p>`
      const subject = 'Puhelinhaastattelun varaus'
      store.dispatch('appApplications/sendInterviewEmail', {
        to,
        message: body,
        subject,
      })
    },
    handleMissedCall() {
      const currentTime = new Date().toLocaleString('fi', {
        weekday: 'long',
        day: 'numeric',
        month: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      })
      const { firstName } = this.userData
      const to = this.userData.email
      const message = `<p style="text-transform: capitalize">Hei ${firstName},</p>
                       <p>Yritimme soittaa sinulle ${currentTime}.</p>
                       <p>Ystävällisin terveisin,</p>
                       <p>Hoiwa - tiimi</p>`
      const subject = 'Yritimme soittaa'
      store.dispatch('appApplications/sendInterviewEmail', {
        to,
        message,
        subject,
      })
    },
    handleReject() {
      this.interviewing = false
      const message = `Peruste: ${this.rejectReason}`
      this.$emit('action', 'rejected', { duration: 0, content: { message } })
      /* const to = this.userData.email
      const { firstName } = this.userData
      const body = `<p style="text-transform: capitalize">Hei ${firstName},</p>
                       <p>Kiitos, että hait Hoiwalle. Tässä yhteydessä olemme päättäneet olla jatkamatta hakemustasi.
                       <p>Haluan kiittää sinua ajasta ja vaivannäöstä, jonka käytit hakemukseesi. Olimme erityisen vaikuttuneita kokemuksesi laajuudesta. Et kuitenkaan täytä kaikkia vaatimuksiamme.</p>
                       <p>Vaikka et onnistunut tässä tilanteessa, kehotamme sinua yrittämään uudelleen tulevaisuudessa, jos tilanteesi muuttuu ja uskot täyttäväsi vaatimuksimme.</p>
                       <p>Ystävällisin terveisin,</p>
                       <p>Hoiwa - tiimi</p>`
      const subject = 'Hakemuksesi Hoiwalle'
      store.dispatch('appApplications/sendInterviewEmail', {
        to,
        message: body,
        subject,
      }) */
    },
    handleAccept() {
      this.interviewing = false
      this.accepted = true
      const update = {
        workContract: {
          signed: false,
          sent: false,
          documentUuid: null,
        },
        confirmed: true,
        role: this.userData.profession,
        status: 'accepted',
      }
      const message = this.acceptReason
      // Handle here student conversion
      if (this.userData.profession === 'opiskelija' && this.studyType && this.creditPoints) {
        const role = this.canWorkAs.value
        update.role = role
        update.studies = {
          credits: parseInt(this.creditPoints, 10),
          studyType: this.studyType,
        }
      }
      this.$emit('action', 'accepted', { duration: 0, content: { message }, update })
    },
    addQuestion() {
      this.form.steps.push({
        question: null,
        questionType: 'text',
      })
    },
    onModalOpen() {
      if (this.userData.email && this.userData.email.length > 0) {
        this.form.email = this.userData.email
      }
      this.form.assignedTo = this.userData.id
    },
    handleCreate() {
      if (this.form.steps.length > 0 && this.$refs.rules.validate()) {
        this.handleSubmit()
      }
    },
    async handleSave() {
      try {
        await this.createTemplate({
          ...this.form,
          templateName: this.templateName,
          isTemplate: true,
          assignedTo: '',
        })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Template created.',
            icon: 'CheckIcon',
            variant: 'info',
          },
        })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('error'),
            text: this.$t('something_went_wrong'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    handleSubmit() {
      this.$refs.rules.validate().then(async success => {
        if (success) {
          try {
            const interview = { ...this.form }
            interview.steps = [...this.form.steps]
            interview.steps.unshift({
              question: '',
              questionType: 'audioTest',
              video: '',
              answer: '',
            })
            interview.created = new Date()
            interview.progress = 0
            interview.expiredDate = this.getExpiredDate(new Date()) // 7 days from today
            interview.token = 'token'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Sending interview...',
                icon: 'CheckIcon',
                variant: 'info',
              },
            })
            this.$bvModal.hide('question-modal')
            await this.onCreateInterview(interview)
            this.isCreatingInterview = false
            this.$emit('action', 'send_interview', { duration: 0, content: {} })
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Interview sent',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('error'),
                text: this.$t('something_went_wrong'),
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        }
      })
    },
    onRemoveQuestion(index) {
      this.form.steps.splice(index, 1)
    },
    getExpiredDate(createdDate) {
      const endDate = new Date(createdDate.setDate(createdDate.getDate() + 7))
      const nowTimeDate = new Date(endDate)
      return new Date(nowTimeDate.setHours(23, 59, 59, 999))
    },

    handleCreateDocumentRequest(documentList) {
      this.$emit('action', 'request_documents', {
        duration: 0,
        content: {
          message: documentList,
        },
      })
    },

    async handleDeleteTemplate() {
      if (this.tempDeleteIndex < 0) {
        return
      }

      const template = this.interviewTemplates[this.tempDeleteIndex].value

      try {
        await this.$store.dispatch('appApplications/deleteInterviewTemplate', { template })
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('toasts.template.delete_template_success'),
            icon: TOAST_VARIABLES.icons.success,
            variant: TOAST_VARIABLES.variants.success,
          },
        })
        this.interviewTemplates.splice(this.tempDeleteIndex, 1)
        if (template.id === this.templateSelection?.id) {
          this.templateSelection = null
        }
      } catch(error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('toasts.template.error_deleting_template'),
            icon: TOAST_VARIABLES.icons.error,
            variant: TOAST_VARIABLES.variants.error,
          },
        })
      }
    }
  },
  setup() {
    const { resolveUserRoleVariant } = useApplicationsList()
    const interviewTemplates = ref([])
    store
      .dispatch('appApplications/getInterviewTemplates')
      .then(response => {
        interviewTemplates.value = response
      })
      .catch(() => {
        interviewTemplates.value = []
      })
    return {
      avatarText,
      resolveUserRoleVariant,
      interviewTemplates,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';

.question-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.b-dropdown {
  ::v-deep .dropdown-toggle {
    text-align: left;
    &::after {
      position: absolute;
      left: unset;
      right: 0.7rem;
      top: 1rem;
    }
  }
}
</style>
